import type { Dispatch, SetStateAction } from 'react'

import { useSearch } from '../search-provider'
import ClientPortal from '../client-portal'
import WideAskAi from './wide-ask-ai'
import useAskAiSettings from './use-ask-ai-settings'

import { cx } from '@/utils/strings'
import { isPrint } from '@/utils/print'

const { VITE_ALGOLIA_AI_AGENT_ID, VITE_ALGOLIA_AI_AGENT_ID_SALES } = import.meta.env

type FloatingWideAskAiProps = {
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
}

export default function FloatingWideAskAi({ isOpen, setIsOpen }: FloatingWideAskAiProps) {
  const { askAiAgent } = useSearch()
  const askAiSettings = useAskAiSettings()

  if (askAiSettings?.enabled === false || isPrint()) return null
  return (
    <ClientPortal>
      <div
        aria-hidden="true"
        className={cx(
          'fixed inset-x-0 bottom-0 z-40 h-full bg-gradient-to-t transition-opacity duration-500',
          'from-black/90 to-black/0 dark:from-black dark:to-secondary-900/0 from-0% to-25%',
          isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
        onClick={() => setIsOpen(false)}
      />
      <div className="fixed bottom-4 left-0 right-0 z-50">
        <WideAskAi
          variant="glow"
          agentId={
            askAiAgent === 'sales'
              ? VITE_ALGOLIA_AI_AGENT_ID_SALES || VITE_ALGOLIA_AI_AGENT_ID
              : VITE_ALGOLIA_AI_AGENT_ID
          }
          isOpen={isOpen}
          setIsOpen={setIsOpen}
        />
      </div>
    </ClientPortal>
  )
}
